

module.exports = __webpack_require__.stylable.create(
    "Footer1433305804",
    {"classes":{"root":"Footer1433305804__root","textAlignmentMixin":"Footer1433305804__textAlignmentMixin","benefits":"Footer1433305804__benefits","arrow":"Footer1433305804__arrow","bulletIcon":"Footer1433305804__bulletIcon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Footer1433305804",
    null
);
